import { useMemo } from "react";
import CollapseIconLink from "./CollapseIconLink";
import DropdownOptionWithIcon from "components/Menus/DropdownOptionWithIcon";
import { useParams, useNavigate } from "react-router-dom";
import _ from "underscore";
import { useAtom, useAtomValue } from "jotai";
import { activeLinkAtom } from "atoms/SidebarAtoms";
import { modulesAtom } from "atoms/GlobalAtoms";
import PopoverDropdownMenu from "components/Menus/PopoverDropdownMenu";

const ModuleLinks = ({ open }) => {
  const [activeLink, setActiveLink] = useAtom(activeLinkAtom);
  const navigate = useNavigate();
  const { tenantID } = useParams();
  const modules = useAtomValue(modulesAtom);
  const sortedModules = useMemo(() => _.sortBy(modules, "Name"), [modules]);

  const ModuleLinksOptions = (module) => {
    const openSettings = () => {
      navigate(
        "/clouds/" +
          tenantID +
          "/settings/modules/manage/" +
          module.APIName +
          "/fields"
      );

      setActiveLink(null);
    };

    return (
      <PopoverDropdownMenu>
        <DropdownOptionWithIcon
          name="Settings"
          onClick={openSettings}
          icon="mdi mdi-cog-outline"
        ></DropdownOptionWithIcon>
      </PopoverDropdownMenu>
    );
  };

  return (
    <CollapseIconLink
      item={{
        icon: "mdi mdi-database-outline",
        name: "All Data Sources",
        children: sortedModules?.map((module) => ({
          name: module.Name,
          path: `/clouds/${tenantID}/records/${module.APIName}`,
          options: ModuleLinksOptions(module),
          id: module.APIName,
          icon: "mdi mdi-database-outline",
        })),
      }}
      type="Direct"
      bold={false}
      sidebarOpen={open}
      activeLink={activeLink}
      setActiveLink={setActiveLink}
    />
  );
};

export default ModuleLinks;
